import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const billingApi = {
  async listInvoices(params = {}) {
    const response = await apiClient.get("/billing/invoices", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async getInvoice(id) {
    const response = await apiClient.get(`/billing/invoices/${id}`);
    return unwrapEnvelope(response.data, null);
  },

  async createInvoice(payload) {
    const response = await apiClient.post("/billing/invoices", payload);
    return unwrapEnvelope(response.data, null);
  },

  async updateInvoice(id, payload) {
    const response = await apiClient.patch(`/billing/invoices/${id}`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async payInvoice(id, payload) {
    const response = await apiClient.post(`/billing/invoices/${id}/pay`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async addAdjustment(id, payload) {
    const response = await apiClient.post(`/billing/invoices/${id}/adjustments`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async requestAdjustmentApproval(invoiceId, adjustmentId) {
    const response = await apiClient.post(`/billing/invoices/${invoiceId}/adjustments/${adjustmentId}/request-approval`, {});
    return unwrapEnvelope(response.data, null);
  },

  async approveAdjustment(invoiceId, adjustmentId, payload = {}) {
    const response = await apiClient.post(`/billing/invoices/${invoiceId}/adjustments/${adjustmentId}/approve`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async rejectAdjustment(invoiceId, adjustmentId, payload = {}) {
    const response = await apiClient.post(`/billing/invoices/${invoiceId}/adjustments/${adjustmentId}/reject`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async countInvoices(params = {}) {
    const response = await apiClient.get("/billing/invoices/count", { params });
    return unwrapEnvelope(response.data, { count: 0 });
  }
};
